import { useTranslation } from "react-i18next";
import facebook from "../../assets/images/socials/facebook.png";
import instagram from "../../assets/images/socials/instagram.png";
import whatsapp from "../../assets/images/socials/whatsapp.png";
import telegram from "../../assets/images/socials/telegram.png";
import logoFooter from "../../assets/images/logo/BannerISFsmall-transparent.png";
import { Link } from "react-router-dom";
import { visitWhatsapp } from "../Shared/Whatsapp";
import { FaFacebook, FaInstagram, FaWhatsapp, FaTelegram, FaCopyright } from "react-icons/fa";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gradient-to-r from-gray-50 to-gray-100 border-t border-gray-200 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-center">
          
          {/* Logo and Copyright Section */}
          <div className="text-center md:text-left space-y-4">
            <div className="flex justify-center md:justify-start">
              <img 
                alt="ISF Logo" 
                className="w-32 h-auto transition-transform duration-300 hover:scale-105" 
                src={logoFooter} 
              />
            </div>
            <div className="flex items-center justify-center md:justify-start gap-2 text-sm text-gray-600">
              <FaCopyright className="text-gray-500" />
              <span>Copyright © {new Date().getFullYear()}</span>
            </div>
            <p className="text-sm text-gray-600 max-w-xs">
              {t("footer.allrights")} Intercambios Sin Fronteras.
            </p>
          </div>

          {/* Links Section */}
          <div className="text-center md:text-center space-y-3">
            <h3 className="text-lg font-semibold text-gray-800 mb-3">
              Enlaces Importantes
            </h3>
            <div className="flex flex-col space-y-2">
              <Link 
                to="/terminos-y-condiciones"
                className="text-gray-600 hover:text-green-admin transition-colors duration-300 font-medium hover:underline"
              >
                {t("footer.terms")}
              </Link>
              <Link 
                to="/politica-de-privacidad"
                className="text-gray-600 hover:text-green-admin transition-colors duration-300 font-medium hover:underline"
              >
                {t("footer.policiy")}
              </Link>
            </div>
          </div>

          {/* Social Media Section */}
          <div className="text-center md:text-center space-y-3">
            <h3 className="text-lg font-semibold text-gray-800 mb-3">
              Síguenos
            </h3>
            <div className="flex justify-center md:justify-center space-x-4">
              <a
                href="https://www.facebook.com/ISFCAMBIOS"
                target="_blank"
                rel="noopener noreferrer"
                className="group p-3 bg-white rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:scale-110 hover:bg-green-admin/10"
                aria-label="Síguenos en Facebook"
              >
                <FaFacebook className="w-5 h-5 text-gray-600 group-hover:text-green-admin transition-colors duration-300" />
              </a>
              
              <a
                href="https://www.instagram.com/isfcambios/?hl=es"
                target="_blank"
                rel="noopener noreferrer"
                className="group p-3 bg-white rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:scale-110 hover:bg-green-admin/10"
                aria-label="Síguenos en Instagram"
              >
                <FaInstagram className="w-5 h-5 text-gray-600 group-hover:text-green-admin transition-colors duration-300" />
              </a>
              
              <button
                onClick={() => visitWhatsapp()}
                className="group p-3 bg-white rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:scale-110 hover:bg-green-admin/10 cursor-pointer"
                aria-label="Chatear por WhatsApp"
              >
                <FaWhatsapp className="w-5 h-5 text-gray-600 group-hover:text-green-admin transition-colors duration-300" />
              </button>
              
              <a
                href="https://t.me/ISFcambiosadmin"
                target="_blank"
                rel="noopener noreferrer"
                className="group p-3 bg-white rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:scale-110 hover:bg-green-admin/10"
                aria-label="Únete a nuestro canal de Telegram"
              >
                <FaTelegram className="w-5 h-5 text-gray-600 group-hover:text-green-admin transition-colors duration-300" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Divider */}
        <div className="border-t border-gray-200 mt-8 pt-6">
          <div className="text-center text-sm text-gray-500">
            <p>Intercambios Sin Fronteras - Tu socio de confianza en el mundo digital</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
